import React, { useState, useEffect } from "react";
import styled from "styled-components";
import EquipmentCard from "../../components/ui/EquipmentCard";
import { farmProduct } from "../../assets/farmProduct";

const PRODUCTS_PER_PAGE =12;

const AllEquipments = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filteredProducts = farmProduct.filter((product) => {
    const term = searchTerm.toLowerCase().trim();
    return (
      term === "" ||
      product.name?.toLowerCase().includes(term) ||
      product.id?.toString().toLowerCase().includes(term) ||
      product.stockNumber?.toString().toLowerCase().includes(term)
    );
  });

  const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);
  const startIndex = (currentPage - 1) * PRODUCTS_PER_PAGE;
  const currentProducts = filteredProducts.slice(
    startIndex,
    startIndex + PRODUCTS_PER_PAGE,
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (currentPage <= 4) {
      for (let i = 1; i <= 5; i++) pages.push(i);
      pages.push("...");
      pages.push(totalPages);
    } else if (currentPage >= totalPages - 3) {
      pages.push(1);
      pages.push("...");
      for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      pages.push("...");
      for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
      pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <TheEquipments>
      <div className="note">
        <p>We Only Sell to Certified Suppliers and Distributors</p>
      </div>
      {/* ── SEARCH ROW ── */}
      <div className="controls-row">
        <div className="controls-inner">
          <div className="search-wrap">
            <svg
              className="search-icon"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              className="search-input"
              placeholder="Search by Name or Stock Number..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                className="search-clear"
                onClick={() => setSearchTerm("")}
              >
                &#10005;
              </button>
            )}
          </div>

          <div className="results-meta">
            <span className="results-text">
              Showing{" "}
              <strong>
                {filteredProducts.length === 0
                  ? "0"
                  : `${startIndex + 1}–${Math.min(startIndex + PRODUCTS_PER_PAGE, filteredProducts.length)}`}
              </strong>{" "}
              of <strong>{filteredProducts.length}</strong>
              {searchTerm && (
                <>
                  {" "}
                  matching <strong>"{searchTerm}"</strong>
                </>
              )}
            </span>
            {searchTerm && (
              <button className="clear-all" onClick={() => setSearchTerm("")}>
                Clear
              </button>
            )}
          </div>
        </div>
      </div>

      {/* ── PRODUCTS ── */}
      <div className="products-container">
        {currentProducts.length > 0 ? (
          <>
            <div className="all-equipments">
              {currentProducts.map((product) => (
                <EquipmentCard key={product.id} product={product} />
              ))}
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button
                  className="pg-btn"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &#8592; Prev
                </button>

                <div className="page-numbers">
                  {getPageNumbers().map((page, i) => (
                    <button
                      key={i}
                      className={`pg-num ${currentPage === page ? "active" : ""} ${page === "..." ? "dots" : ""}`}
                      onClick={() => page !== "..." && handlePageChange(page)}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  className="pg-btn"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next &#8594;
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="no-products">
            <p className="no-products-label">No equipment found</p>
            <p className="no-products-sub">No results for "{searchTerm}"</p>
            <button className="reset-btn" onClick={() => setSearchTerm("")}>
              View All Equipment
            </button>
          </div>
        )}
      </div>
    </TheEquipments>
  );
};

const TheEquipments = styled.div`
  width: 100%;
  background: #f5f2ed;
  font-family: "Georgia", "Times New Roman", serif;
  .note{
    width:100%;
    font-size:0.8rem;
    color:red;
    font-weight:600;
    padding:2rem 0 0 1rem;
    display:flex;
    align-items:center;
    justify-content:center;
  }

  /* ── SEARCH ROW ── */
  .controls-row {
    border-bottom: 1px solid #d5d0c8;
    background: #f5f2ed;

    .controls-inner {
      max-width: 1200px;
      margin: 0 auto;
      padding: 1.4rem 2rem;
      display: flex;
      flex-direction: column;
      gap: 0.9rem;
    }
  }

  .search-wrap {
    position: relative;
    width: 100%;

    .search-icon {
      position: absolute;
      left: 0.9rem;
      top: 50%;
      transform: translateY(-50%);
      color: #b0a898;
      pointer-events: none;
    }

    .search-input {
      width: 100%;
      padding: 0.75rem 2.2rem 0.75rem 2.4rem;
      border: 1px solid #d5d0c8;
      background: #fff;
      font-size: 0.88rem;
      font-family: "Georgia", serif;
      color: #1c1c1c;
      border-radius: 0;
      transition: border-color 0.2s;

      &::placeholder {
        color: #b0a898;
      }
      &:focus {
        outline: none;
        border-color: #1c1c1c;
      }
    }

    .search-clear {
      position: absolute;
      right: 0.8rem;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      font-size: 0.7rem;
      color: #b0a898;
      cursor: pointer;
      padding: 0;
      transition: color 0.2s;
      &:hover {
        color: #1c1c1c;
      }
    }
  }

  .results-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    .results-text {
      font-family: "Courier New", monospace;
      font-size: 0.7rem;
      letter-spacing: 0.06em;
      color: #7a7265;
    }

    .clear-all {
      background: none;
      border: none;
      font-family: "Courier New", monospace;
      font-size: 0.65rem;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #7a7265;
      cursor: pointer;
      text-decoration: underline;
      text-underline-offset: 3px;
      padding: 0;
      transition: color 0.2s;
      &:hover {
        color: #1c1c1c;
      }
    }
  }

  /* ── PRODUCTS ── */
  .products-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 3rem 2rem 5rem;
  }

  .all-equipments {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    margin-bottom: 3rem;
  }

  /* ── PAGINATION ── */
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding-top: 2rem;
    border-top: 1px solid #d5d0c8;

    .pg-btn {
      background: transparent;
      border: 1px solid #d5d0c8;
      padding: 0.5rem 1.2rem;
      font-family: "Courier New", monospace;
      font-size: 0.68rem;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #555;
      cursor: pointer;
      transition: all 0.2s;

      &:hover:not(:disabled) {
        border-color: var(--primary-color);
        color: var(--primary-color);
      }
      &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
      }
    }

    .page-numbers {
      display: flex;
      align-items: center;
      gap: 0.35rem;
      flex-wrap: wrap;
      justify-content: center;

      .pg-num {
        min-width: 34px;
        height: 34px;
        background: transparent;
        border: 1px solid #d5d0c8;
        font-family: "Courier New", monospace;
        font-size: 0.72rem;
        color: #555;
        cursor: pointer;
        transition: all 0.2s;

        &:hover:not(.dots) {
          border-color: var(--primary-color);
          color: var(--primary-color);
        }

        &.active {
          background: var(--primary-color);
          border-color: var(--primary-color);
          color: #f5f2ed;
        }

        &.dots {
          border: none;
          background: transparent;
          cursor: default;
          color: #b0a898;
        }
      }
    }
  }

  /* ── EMPTY STATE ── */
  .no-products {
    padding: 5rem 2rem;
    text-align: center;
    border-top: 1px solid #d5d0c8;

    .no-products-label {
      font-family: "Courier New", monospace;
      font-size: 0.72rem;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: #7a7265;
      margin-bottom: 0.8rem;
    }

    .no-products-sub {
      font-size: 1.1rem;
      color: #3d3d3d;
      margin-bottom: 2rem;
      font-style: italic;
    }

    .reset-btn {
      background: transparent;
      color: var(--primary-color);
      border: 1px solid var(--primary-color);
      padding: 0.7rem 2rem;
      font-family: "Courier New", monospace;
      font-size: 0.72rem;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      cursor: pointer;
      transition: all 0.25s ease;

      &:hover {
        background: var(--primary-color);
        color: #f5f2ed;
      }
    }
  }

  /* ── RESPONSIVE ── */
  @media screen and (max-width: 1200px) {
    .all-equipments {
      gap: 1.2rem;
    }
  }

  @media screen and (max-width: 900px) {
    .all-equipments {
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
    }
    .pagination {
      flex-wrap: wrap;
      gap: 0.75rem;
      .page-numbers {
        order: 3;
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .controls-row .controls-inner {
      padding: 1.2rem 1.5rem;
    }
    .products-container {
      padding: 2rem 1.5rem 3rem;
    }
    .all-equipments {
      gap: 0.9rem;
    }
  }

  @media screen and (max-width: 420px) {
    .controls-row .controls-inner {
      padding: 1rem 1.2rem;
    }
    .products-container {
      padding: 1.5rem 1.2rem 2.5rem;
    }
    .all-equipments {
      gap: 0.75rem;
    }
  }

  @media screen and (max-width: 350px) {
    .all-equipments {
      gap: 0.6rem;
    }
  }
`;

export default AllEquipments;
